import { useState } from 'react';
import './Role.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import StyledButton from '../../../components/Button/Button';
import RoleInput from '../../../components/Inputs/RoleInput';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import TopNav from '../../../components/TopNav/TopNav';
import { storeRole } from '../../../utils/auth-token-utils/cookie';

const Role = () => {
  const [role, setRole] = useState<string>('');
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const redirectTo = queryParams.get('redirectTo');

  const onSelectRole = (value: string) => {
    setRole(value);
  };

  const handleContinue = () => {
    storeRole(role);
    if (redirectTo === 'login') {
      navigate('/signin');
    } else {
      navigate('/signup');
    }
  };

  return (
    <StyledBgContainer>
      <TopNav />
      <Container maxWidth="sm" sx={{ mt: { sm: 2 } }}>
        <Box component="form">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              px: { md: 6 },
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: 'white', fontFamily: 'Opensans', fontWeight: '700' }}
            >
              Select Your Role
            </Typography>
            <Typography variant="body2" sx={{ color: 'grey', mt: 1, mb: 3 }}>
              Tap the entity below which describes how you will use the Web
              Portal or Application.
            </Typography>

            <FormControl
              fullWidth
              variant="outlined"
              sx={{ mb: 1, alignItems: 'center' }}
            >
              <RoleInput
                // className="borderstyle input-button"
                type="button"
                selected={role === 'Participant'}
                value="Participant"
                onClick={() => onSelectRole('Participant')}
              />
            </FormControl>
            <FormControl
              fullWidth
              variant="outlined"
              sx={{ mb: 2, alignItems: 'center' }}
            >
              <RoleInput
                type="button"
                selected={role === 'Supervisor'}
                value="Supervisor"
                // placeholder="Babysitter"
                onClick={() => onSelectRole('Supervisor')}
              />
            </FormControl>
          </Box>
        </Box>
        <Box sx={{ mt: { xs: 10 }, mb: 2 }}>
          <StyledButton disabled={!role} onClick={handleContinue}>
            Continue
          </StyledButton>{' '}
        </Box>
      </Container>
    </StyledBgContainer>
  );
};

export default Role;
